<gh-nav-items-list
  *ngIf="sessions && sessions.items.length"
  [collection]="sessions"
  [config]="{ sectionLabelKey: 'sessions', itemsType: 'sessions', itemsGroupType: itemsGroupType, visibleItemsCount: visibleItemsCount }">
</gh-nav-items-list>
<gh-nav-items-list
  *ngIf="kpis && kpis.items.length"
  [collection]="kpis"
  [config]="{ sectionLabelKey: 'kpis', itemsType: 'kpis', itemsGroupType: itemsGroupType, visibleItemsCount: visibleItemsCount }">
</gh-nav-items-list>
<gh-nav-items-list
  *ngIf="tasks && tasks.items.length"
  [collection]="tasks"
  [config]="{ sectionLabelKey: 'tasks', itemsType: 'tasks', itemsGroupType: itemsGroupType, visibleItemsCount: visibleItemsCount }">
</gh-nav-items-list>
<gh-nav-items-list
  *ngIf="whiteboards && whiteboards.items.length"
  [collection]="whiteboards"
  [config]="{ sectionLabelKey: 'whiteboards', itemsType: 'whiteboards', itemsGroupType: itemsGroupType, visibleItemsCount: visibleItemsCount }">
</gh-nav-items-list>
<gh-nav-items-list
  *ngIf="lists && lists.items.length"
  [collection]="lists"
  [config]="{ sectionLabelKey: 'reports', itemsType: 'lists', itemsGroupType: itemsGroupType, visibleItemsCount: visibleItemsCount }">
</gh-nav-items-list>
<gh-nav-items-list
  *ngIf="insightboads && insightboads.items.length"
  [collection]="insightboads"
  [config]="{ sectionLabelKey: 'insightboards', itemsType: 'insightboards', itemsGroupType: itemsGroupType, visibleItemsCount: visibleItemsCount }">
</gh-nav-items-list>
<gh-nav-items-list
  *ngIf="people && people.items.length"
  [collection]="people"
  [config]="{ sectionLabelKey: 'people', itemsType: 'people', itemsGroupType: itemsGroupType, visibleItemsCount: visibleItemsCount }">
</gh-nav-items-list>
